import { atom } from "jotai";

export interface IUnitType {
    id?: number;
    name: string;
    description?: string | null;
    created_at?: string;
    updated_at?: string;
}

export interface IUnitTypeInput extends Omit<IUnitType, 'id' | 'created_at' | 'updated_at'> {}

export const unitTypesAtom = atom<IUnitType[]>([]);
export const unitTypesLoadingAtom = atom<boolean>(false);

